export enum ElementIds {
    messageInput = "inputText",
}
